import { Theme } from '../../../../Enums/Theme.enum';
import LinkButton from '../../../../Components/Button/LinkButton';
import React, { useState } from 'react';
import { useDENTContext } from '../../Services/DENTContext';
import styles from './DENTDentalCrossActions.module.scss';
import DENTDentalCrossStartMedicalExamination from './DENTDentalCrossStartMedicalExamination/DENTDentalCrossStartMedicalExamination';
import { useUpdateDentMedicalExaminationMutation } from '../../../../graphql/graphql';
import useApiClient from '../../../Base/Hooks/useApiClient';
import useNotification from '../../../../Hooks/useNotification.hook';
import Loading from '../../../../Components/Loading';

const DENTDentalCrossActions = () => {
	const [isModalOpened, setIsModalOpened] = useState(false);
	const [isLoading, setIsLoading] = useState(false);

	const { activeMedicalExaminationId, setActiveMedicalExaminationId } =
		useDENTContext();
	const [updateMedicalExamination] = useUpdateDentMedicalExaminationMutation();
	const { displayGQLError } = useApiClient();
	const { showNotificationSuccess } = useNotification();

	const handleFinishMedicalExamination = async () => {
		if (activeMedicalExaminationId) {
			setIsLoading(true);

			const response = await updateMedicalExamination({
				where: { id: activeMedicalExaminationId },
				input: { completedAt: new Date() },
			});

			if ('error' in response) {
				displayGQLError(response);
			} else {
				showNotificationSuccess({
					content:
						'patientTreatment.meddiDENT.dentalCross.actions.dentitionVisit.endSuccess',
				});
				setActiveMedicalExaminationId(undefined);
			}

			setIsLoading(false);
		}
	};

	if (isLoading) {
		return (
			<div className={styles.wrapper}>
				<Loading />
			</div>
		);
	}

	return (
		<div className={styles.wrapper}>
			{activeMedicalExaminationId ? (
				<LinkButton
					title={
						'patientTreatment.meddiDENT.dentalCross.actions.dentitionVisit.end'
					}
					theme={Theme.RED}
					onClick={handleFinishMedicalExamination}
				/>
			) : (
				<LinkButton
					title={
						'patientTreatment.meddiDENT.dentalCross.actions.dentitionVisit.start'
					}
					theme={Theme.BLUE}
					onClick={() => setIsModalOpened(true)}
				/>
			)}
			{isModalOpened && (
				<DENTDentalCrossStartMedicalExamination
					onClose={() => setIsModalOpened(false)}
				/>
			)}
		</div>
	);
};

export default DENTDentalCrossActions;
